var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: "24px",
    viewBox: "0 0 74 74",
    width: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m45.73 4h-6.23a1 1 0 0 1 0-2h6.23a1 1 0 0 1 0 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.54 65.89h-47.08a5.276 5.276 0 0 1 -5.27-5.27v-53.35a5.276 5.276 0 0 1 5.27-5.27h9.81a1 1 0 0 1 0 2h-9.81a3.274 3.274 0 0 0 -3.27 3.27v53.35a3.274 3.274 0 0 0 3.27 3.27h47.08a3.274 3.274 0 0 0 3.27-3.27v-53.35a3.274 3.274 0 0 0 -3.27-3.27h-9.81a1 1 0 0 1 0-2h9.81a5.276 5.276 0 0 1 5.27 5.27v53.35a5.276 5.276 0 0 1 -5.27 5.27z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m34.5 4h-6.23a1 1 0 0 1 0-2h6.23a1 1 0 0 1 0 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m57.328 72h-6.861a2.07 2.07 0 0 1 -2.067-2.067v-5.04a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5.04a2.069 2.069 0 0 1 -2.072 2.067zm-6.928-6.107v4.04l6.928.067.054-4.107z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.533 72h-6.861a2.069 2.069 0 0 1 -2.067-2.067v-5.04a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v5.04a2.07 2.07 0 0 1 -2.072 2.067zm-6.928-6.107v4.04l6.928.067.053-4.107z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m64.805 47.635h-55.605a1 1 0 0 1 -1-1v-31.887a1 1 0 0 1 1-1h55.61a1 1 0 0 1 1 1v31.887a1 1 0 0 1 -1.005 1zm-54.61-2h53.61v-29.887h-53.605z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m53.111 60.684a4.992 4.992 0 1 1 4.989-4.992 5 5 0 0 1 -4.989 4.992zm0-7.983a2.992 2.992 0 1 0 2.989 2.991 2.995 2.995 0 0 0 -2.989-2.992z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m20.889 60.684a4.992 4.992 0 1 1 4.991-4.992 5 5 0 0 1 -4.991 4.992zm0-7.983a2.992 2.992 0 1 0 2.991 2.991 2.995 2.995 0 0 0 -2.991-2.992z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m46.9 9.664h-19.8a1 1 0 0 1 0-2h19.8a1 1 0 0 1 0 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m68.223 31.908h-3.418a1 1 0 1 1 0-2h3.418a1.008 1.008 0 0 0 1.007-1.008v-9.461a1.008 1.008 0 0 0 -1.007-1.006h-3.418a1 1 0 0 1 0-2h3.418a3.01 3.01 0 0 1 3.007 3.006v9.461a3.01 3.01 0 0 1 -3.007 3.008z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m37 47.635a1 1 0 0 1 -1-1v-31.887a1 1 0 1 1 2 0v31.887a1 1 0 0 1 -1 1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m44.237 54.348h-14.474a1 1 0 0 1 0-2h14.474a1 1 0 1 1 0 2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m44.237 59.068h-14.474a1 1 0 0 1 0-2h14.474a1 1 0 1 1 0 2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m9.2 31.908h-3.423a3.01 3.01 0 0 1 -3.007-3.008v-9.461a3.01 3.01 0 0 1 3.007-3.006h3.423a1 1 0 0 1 0 2h-3.423a1.008 1.008 0 0 0 -1.007 1.006v9.461a1.008 1.008 0 0 0 1.007 1.006h3.423a1 1 0 0 1 0 2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.4033ac28.svg";
export { ForwardRef as ReactComponent };